import axios from '../axios'
import configurations from '../configurations'

const defaultData = {
  confirm_password: '',
  password: ''
}

const reset = {
  namespaced: true,
  state: {
    data: defaultData,
    email: '',
    error: null,
    loading: false,
    rules: {
      confirm_password: 'required|confirmed:password',
      password: 'required'
    },
    success: false
  },
  getters: {
    isLoading: function (state) {
      return state.loading
    }
  },
  actions: {
    patchData: async function (context, payload = {}) {
      const data = Object.assign({}, context.state.data, payload)
      context.commit('setData', { data })
    },
    patchId: async function (context, payload = '') {
      const id = payload
      try {
        const response = await axios.post(configurations.WORKER + `/query`, { url: btoa(`/reset_password/${id}`) })
        if (response._id) {
          var timestampID = response._id.substring(0, 14)
          var timestamp = parseInt(timestampID, 16) / 1000
          timestamp += 86400000
          if (new Date().getTime() <= timestamp) {
            context.commit('setEmail', { email: response.email })
            context.commit('setError', { error: null })
            context.commit('setSuccess', { success: true })
            return response
          } else {
            context.commit('setError', { error: { error: 'Invalid Request' } })
            return { error: 'Invalid Request' }
          }
        } else {
          context.commit('setError', { error: { error: 'Invalid Request' } })
          return response
        }
      } catch (error) {
        context.commit('setError', { error: { error: 'Server Error' } })
        return error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    resetData: async function (context) {
      context.commit('setData', { data: defaultData })
    },
    submitData: async function (context) {
      const user = await axios.post(configurations.WORKER + `/query`, { url: btoa(`/_users/org.couchdb.user:${context.state.email}`) })
      const data = {
        full_name: user.full_name,
        ic_num: user.ic_num,
        machine_id: user.machine_id,
        name: user.name,
        password: context.state.data.confirm_password,
        phone: user.phone,
        roles: ['user'],
        type: 'user'
      }
      const apiUrl = `/_users/${user._id}`
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.post(configurations.WORKER + `/query`, { url: btoa(apiUrl), payload: data })
        context.commit('setData', { data: defaultData })
        context.commit('setError', { error: null })
        context.commit('setSuccess', { success: true })
        return response
      } catch (error) {
        context.commit('setError', { error })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  },
  mutations: {
    setData: function (state, payload = { data: defaultData }) {
      state.data = payload.data
    },
    setEmail: function (state, payload = {}) {
      state.email = payload.email
    },
    setError: function (state, payload = { error: null }) {
      state.error = payload.error
    },
    setLoading: function (state, payload = { loading: false }) {
      state.loading = payload.loading
    },
    setSuccess: function (state, payload = { success: false }) {
      state.success = payload.success
    }
  }
}

export default reset
